import Image from 'next/image';
import { ClueCard } from '@snapi/luxury';

import BabyIllistration from './images/baby-illustration.png';
import UnderlineIllustration from './images/underline-illustration.png';
import BabyImage from './images/baby.png';
import BabyImageLittle from './images/baby-why-little-version.png';

export function WhySectionScience() {
  return (
    <section id="why-section-science">
      <div className="relative w-full container">
        <div className="absolute top-[-30px] right-0 w-[96px] sm:right-[40px] lg:w-[174px] lg:top-[-110px] xl:top-[-120px]">
          <Image src={BabyIllistration} alt="" />
        </div>

        <div className="relative flex items-end">
          <div className="relative flex">
            <h2 className="relative w-[170px] text-[28px] sm:w-[328px] md:text-[32px] text-start mb-3">
              Why is it important?
              <div className="absolute w-[200px] bottom-[-40px] sm:left-[90px] md:left-[120px]">
                <Image src={UnderlineIllustration} alt="" />
              </div>
              <div
                className="absolute text-center w-[200px] font-mono text-body font-normal sm:w-[226px] bottom-[2px] 
                           right-[-114px] sm:right-[-94px] md:right-[-134px] text-[24px]"
              >
                <ClueCard
                  description="The significance of the enteric microbiome on the development of childhood disease: A review of prebiotic and probiotic therapies in disorders of childhood."
                  href="https://doi.org/10.4137/CMPed.S38338"
                  orientation="bottom"
                />
              </div>
            </h2>
          </div>
        </div>
        <div className="flex flex-col gap-2 sm:w-[446px] md:w-full md:flex-row md:gap-9 lg:gap-7 mb-10 text-body">
          <p className="md:w-[320px] lg:w-[460px] xl:w-[540px]">
            Our microbiome is originally determined by our DNA and is unique 
            to each person. However, exposure to food and the environment can 
            change our microbiome, supporting a healthy life, but also resulting 
            in a greater risk of developing diseases or conditions when it is not 
            properly cared for.
            <span className="hidden md:block mt-2">
              A recent study demonstrated that 9 out of 10 infants experience gut 
              microbiome deficiencies. The research determined that infants with 
              microbiome deficiencies were at greater risk for decreased nutrient 
              digestion and absorption, gastrointestinal issues,
            </span>
          </p>
          <p className="md:w-[320px] md:hidden">
            A recent study demonstrated that 9 out of 10 infants experience gut 
            microbiome deficiencies. The research determined that infants with 
            microbiome deficiencies were at greater risk for decreased nutrient 
            digestion and absorption, gastrointestinal issues, increased exposure 
            to pathogens, and decreased immune system function.
          </p>
          <p className="md:w-[320px] lg:w-[460px] xl:w-[540px]">
            <span className="hidden md:block mb-2">
              increased exposures to pathogens, and
              decreased immune system function.
            </span>
              We now know that the first 1000 days of life are the most important 
              for the development of the gut microbiome. This time period is considered 
              a window of opportunity. That’s why early-stage gut microbiome testing 
              can help us understand what is happening in our baby’s gut in order to 
              guide the decisions we make.
          </p>
        </div>
        <div className="hidden sm:block min-h-[280px] relative md:h-[320px] lg:h-[400px]">
          <Image src={BabyImage} alt="" layout="fill" />
        </div>
        <div className="sm:hidden min-w-[280px]">
          <Image src={BabyImageLittle} alt="" />
        </div>
      </div>
    </section>
  );
}
